export default {
  label: '人力资源助理',
  id: '0',
  children: [
    {
      label: '岗位定义',
      id: '0-1',
      children: [
        {
          label: '人力资源助理是人力资源部门的基础岗位，主要协助上级完成日常的人力资源管理工作，是进入人力资源领域的初级职位',
          id: '0-1-1',
        },
      ],
    },
    {
      label: '岗位职责',
      id: '0-2',
      children: [
        {
          label: '协助上级完成招聘、培训、薪酬福利、员工关系等基础性工作',
          id: '0-2-1',
        },
        {
          label: '负责员工入离职手续办理、考勤管理、社保公积金报税等工作',
          id: '0-2-2',
        },
        {
          label: '维护人事档案，处理劳动合同的更新和办理',
          id: '0-2-3',
        },
        {
          label: '协助开展新员工入职培训和业务培训',
          id: '0-2-4',
        }
      ],
    },
    {
      label: '技能要求',
      id: '0-3',
      children: [
        {
          label: '大专及以上学历，人力资源、行政管理等相关专业优先',
          id: '0-3-1',
        },
        {
          label: '熟练使用办公软件，具备良好的沟通能力和团队合作精神',
          id: '0-3-2',
        },
        {
          label: '具备较强的责任心和敬业精神，能够承受一定的工作压力',
          id: '0-3-3',
        }
      ],
    }
  ],
};